export default __webpack_public_path__ + "static/hero-splash-e0977e8f191db961a4a073002070682e.mp4";